import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { agentTokenInterceptor } from './interceptors/agent-token.interceptor';
import { authInterceptor } from './interceptors/auth.interceptor';
import { ClerkAuthService } from './services/clerk-auth.service';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    // Jeton Clerk sur /admin-api/*, jeton joueur sur /api/missions/*.
    provideHttpClient(withInterceptors([authInterceptor, agentTokenInterceptor])),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    provideAppInitializer(() => {
      const clerkAuth = inject(ClerkAuthService);
      return clerkAuth.initialize();
    }),
  ],
};
